import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '@/lib/api';
import { getSEO } from '@/data/seo';

export default function SEOHead({
  title,
  description,
  keywords,
  path = '/',
  image,
  type = 'website',
  jsonLd,
  fullTitle = false,
  noindex = false,
}) {
  // Look up canonical SEO data by path; explicit props always win.
  const fromMap = getSEO(path) || {};
  const resolvedTitle = title || fromMap.title || 'Ads Dashbound | Premium Performance Traffic Platform';
  const resolvedFullTitle = fullTitle || fromMap.fullTitle;
  const finalTitle = resolvedFullTitle ? resolvedTitle : `${resolvedTitle} | Ads Dashbound`;
  const desc = description || fromMap.description || 'Ads Dashbound helps advertisers scale campaigns with curated traffic formats, source-level controls, and top-up based campaign funding.';
  const kw = keywords || fromMap.keywords;
  const url = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/og-image.png`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{finalTitle}</title>
      <meta name="description" content={desc} />
      {kw && <meta name="keywords" content={kw} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ads Dashbound — Premium Performance Traffic Platform" />
      <meta property="og:site_name" content="Ads Dashbound" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
